<template>
  <div class="page-container" >
    <!-- 顶部操作面板 -->
    <div class="top-operate-panel">
      <el-form class="operate-form" inline :model="queryForm">
        <el-form-item :label="$str.getKey('收益管理/')">
          <el-date-picker class="mx-[10px]" type="daterange" :clearable="false"
            :range-separator="$str.getKey('收益管理/至')" :start-placeholder="$str.getKey('收益管理/开始日期')" :end-placeholder="$str.getKey('收益管理/结束日期')"
            v-model="queryForm.timer" @change="timeRangeChange" :disabled-date="disabledDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div style="margin-left:10px">
            <el-button type="primary" @click="freshPageData">{{ $str.getKey('收益管理/查询') }}</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 抄表详情面板 -->
    <div class="read-meter-container">
      <!-- 标题-打印-导出 -->
      <div class="panel-header-container">
        <div class="titel-text">{{ $str.getKey('收益管理/抄表详情') }}</div>
        <div class="operate-btns">
          <el-button type="primary" class="btn-print" @click="printFunc">
          <!-- <el-button type="primary" class="btn-print" v-print="'#print-panel'"> -->
            <el-icon style="margin-right: 6px"> <Printer /> </el-icon>{{ $str.getKey('收益管理/打印') }}
          </el-button>
          <el-button @click="onExport" type="default" class="btn-export" plain>
            <el-icon class="el-icon--right" style="margin-right: 6px"><Upload /> </el-icon>{{ $str.getKey('收益管理/导出') }}
          </el-button>
        </div>
      </div>
      <!-- 表格数据 -->
      <div ref="meterDetails" class="panel-details-container" id="print-panel">
        <!-- 表格数据 -->
        <el-table
          class="table-content disable-hover" stripe border show-summary
          v-loading="loading" :element-loading-text="$str.getKey('收益管理/Loading...')"
          :data="tableInfo.dataList"
          :span-method="mergeCellsMethod"
          :cell-class-name="setClassNameForCell"
          :summary-method="getSummaries"
        >
          <el-table-column prop="id" :label="$str.getKey('收益管理/收益类别')"> </el-table-column>
          <el-table-column prop="priceType" :label="$str.getKey('收益管理/电价类型')" width="120"> </el-table-column>
          <el-table-column prop="priceName" :label="$str.getKey('收益管理/电价名称')" width="200">
          </el-table-column>
          <el-table-column prop="dayCount" :label="$str.getKey('收益管理/天数')" width="180">
            <template #default="{ row }">
              <div>
                <div>{{row.dayCount}} {{ $str.getKey('收益管理/天') }}</div>
                <div v-for="timeRange in row.timeRanges" :style="{'font-size': '12px', 'margin-top': '10px'}">
                  <div>{{timeRange.startTime}}{{$str.getKey('收益管理/至')}}{{timeRange.endTime}}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="timeRangeName" :label="$str.getKey('收益管理/时段')"></el-table-column>
          <el-table-column prop="price" :label="$str.getKey('收益管理/市电单价(元/kWh)')"></el-table-column>
          <el-table-column prop="direction" :label="$str.getKey('收益管理/计量方向')">
            <template #default="{ row }">
              <div v-if="row.direction === $str.getKey('收益管理/充电')" class="charge-type-cell">
                <span class="circle-symbol" :style="{ color: tableInfo.styleInfo.rechargeColor }"></span>
                <span>{{ $str.getKey('收益管理/充电') }}</span>
              </div>
              <div v-else class="charge-type-cell">
                <span class="circle-symbol" :style="{ color: tableInfo.styleInfo.dischargeColor }"></span>
                <span>{{ $str.getKey('收益管理/放电') }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="electricQuantity" :label="$str.getKey('收益管理/电量(kWh)')"></el-table-column>
          <el-table-column prop="electricCharge" :label="$str.getKey('收益管理/电费(元)')"></el-table-column>
          <el-table-column prop="totalAmount" :label="$str.getKey('收益管理/合计(元)')" class="income" id="income"></el-table-column>
        </el-table>

        <!-- 注意信息 -->
        <div class="remark-info-container">
          <span v-for="item in origin.remarkInfoList" :key="item" class="info-text">{{ item }}</span>
        </div>
      </div>
    </div>
    <!-- 电表数据详情面板 -->
    <div class="meter-datalist-container">
      <div class="content-title">
        <span class="text">{{ $str.getKey('收益管理/电表数据详情') }}</span>
      </div>
      <el-tabs v-loading="loading" :element-loading-text="$str.getKey('收益管理/Loading...')">
        <el-tab-pane v-for="item in meterInfo.dataList" :key="item.uuid" :label="item.meterName">
          <el-timeline v-if="item.meterList && item.meterList.length > 0">
            <el-timeline-item v-for="(mt, idx) in item.meterList" :key="idx">
              <!-- 时间线的symbol-icon -->
              <template #dot>
                <div class="timeline-dot-symbol"></div>
              </template>
              <!-- 抄表信息项 -->
              <ReadMeterCard :data="mt" style="margin-top: 16px" />
            </el-timeline-item>
          </el-timeline>
          <div v-else class="timeline-empty">
            <span>{{ $str.getKey('收益管理/暂无数据') }}</span>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, getCurrentInstance, computed, watch } from "vue";
import { getPeriodPrice } from "./api/index.js";
import { download, download_get } from "@/api/modules/download/index.js";
import html2canvas from "html2canvas";
import dayjs from "dayjs";
import { ElMessageBox } from "element-plus";
import { cloneDeep } from "@/utils"
import ReadMeterCard from "./readMeterCard.vue";

import useAppStore from "@/store/modules/app";

const $str = window.$str;
const appStore = useAppStore();
/** 获取stationId，并监听其变化-更新数据 */
const stationId = computed(() => appStore.stationId);

// 先定义所有变量，避免在 watch 中使用时出现初始化错误
const meterDetails = ref(null); // 引用【抄表详情】的table的容器
const loading = ref(false);
const queryForm = reactive({
  timer: [
    dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD"), // 上月第一天
    dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD") // 上月最后一天
  ]
});
const tableInfo = reactive({
  dataList: [],
  totalPrice: 0,
  styleInfo: {
    priceList: [],
    rechargeColor: "#21C976",
    dischargeColor: "#FF6C24",
  },
})
const meterInfo = reactive({
  dataList: [],
})

const origin = {
  remarkInfoList: [
    $str.getKey('收益管理/注：甲方每月支付乙方的储能服务费为峰谷价差收益的总和，其中电量计量以储能电站并网点总表计量为准，对应时段度电电价以当地供电部门实际执行电价为准，具体计算公式如下：'),
    $str.getKey('收益管理/1. 放电电费 = ∑(储能系统各时段（峰、平、谷、（深谷））并网点总表放电电量 ×对应时段度电电价)'),
    $str.getKey('收益管理/2. 充电电费 = ∑(储能系统各时段（峰、平、谷、（深谷））并网点总表充电电量 × 对应时段度电电价)'),
    $str.getKey('收益管理/3. 峰谷价差收益 = 放电电费 - 充电电费'),
    $str.getKey('收益管理/4. 储能电站收益 = 峰谷价差收益')
  ],
  priceKeyMap: {
    in_sharp_price: {
      timeRangeName: $str.getKey('收益管理/尖峰时段'),
      price: "--",
      direction: $str.getKey('收益管理/充电'),
      electricQuantity: "ePositiveSharp", // 电量,用该Key取电量的值
    },
    out_sharp_price: {
      timeRangeName: $str.getKey('收益管理/尖峰时段'),
      price: "--",
      direction: $str.getKey('收益管理/放电'),
      electricQuantity: "eReverseSharp",
    },
    // in_higher_peak_price: {
    //   timeRangeName: "高峰时段",
    //   price: "--",
    //   direction: "充电",
    //   electricQuantity: "ePositiveHigherPeak",
    // },
    // out_higher_peak_price: {
    //   timeRangeName: "高峰时段",
    //   price: "--",
    //   direction: "放电",
    //   electricQuantity: "eReverseHigherPeak",
    // },
    in_peak_price: {
      timeRangeName: $str.getKey('收益管理/高峰时段'),
      price: "--",
      direction: $str.getKey('收益管理/充电'),
      electricQuantity: "ePositivePeak",
    },
    out_peak_price: {
      timeRangeName: $str.getKey('收益管理/高峰时段'),
      price: "--",
      direction: $str.getKey('收益管理/放电'),
      electricQuantity: "eReversePeak",
    },
    in_flat_price: {
      timeRangeName: $str.getKey('收益管理/平时段'),
      price: "--",
      direction: $str.getKey('收益管理/充电'),
      electricQuantity: "ePositiveFlat",
    },
    out_flat_price: {
      timeRangeName: $str.getKey('收益管理/平时段'),
      price: "--",
      direction: $str.getKey('收益管理/放电'),
      electricQuantity: "eReverseFlat",
    },
    in_valley_price: {
      timeRangeName: $str.getKey('收益管理/低谷时段'),
      price: "--",
      direction: $str.getKey('收益管理/充电'),
      electricQuantity: "ePositiveValley",
    },
    out_valley_price: {
      timeRangeName: $str.getKey('收益管理/低谷时段'),
      price: "--",
      direction: $str.getKey('收益管理/放电'),
      electricQuantity: "eReverseValley",
    },
    in_deep_valley_price: {
      timeRangeName: $str.getKey('收益管理/深谷时段'),
      price: "--",
      direction: $str.getKey('收益管理/充电'),
      electricQuantity: "ePositiveDeepValley",
    },
    out_deep_valley_price: {
      timeRangeName: $str.getKey('收益管理/深谷时段'),
      price: "--",
      direction: $str.getKey('收益管理/放电'),
      electricQuantity: "eReverseDeepValley",
    },
  },
  tableRowInfo: {
    id: $str.getKey('收益管理/峰谷价差收益'),
    priceType: '', // 电价类型
    priceName: '', // 电价名称
    dayCount: '', // (使用该电价)天数
    startTime: '', // 开始时间
    endTime: '', // 结束时间
    timeRangeName: '', // 时段名称
    price: '', // 市电电价
    direction: '', // 计量方向
    electricQuantity: '', // 电量
    electricCharge: '', // 电费
    totalAmount: '', // 合计(总电费)
  },
  priceTypeMap: {
    1: $str.getKey('收益管理/基本电价'),
    2: $str.getKey('收益管理/基本电价'),
    3: $str.getKey('收益管理/自定义电价'),
  },
}

// 监听 stationId 变化
watch(() => appStore.stationId, (newStationId) => {
  if (newStationId) {
    // 刷新页面数据
    freshPageData();
  }
}, { immediate: true });

/** ===== 交互方法：响应DOM的交互 ============================================================================ */
/** 刷新页面数据 */
function freshPageData() {
  // 从接口查询，更新页面数据
  const params = {
    startTime: dayjs(queryForm.timer[0]).format("YYYY-MM-DD 00:00:00"),
    endTime: dayjs(queryForm.timer[1]).format("YYYY-MM-DD 23:59:59"),
    stationId: stationId.value
  };
  loading.value = true;
  getPeriodPrice(params).then(res => {
    // 设置【抄表详情】面板的表格数据
    if (Array.isArray(res?.data?.total)) {
      setTableData(res.data.total);
    }

    // 设置【电表数据详情】面板的各tabs数据
    if (Array.isArray(res?.data?.meterList)) {
      setMeterList(res.data.meterList);
    }

  }).finally(() => {
    loading.value = false;
  })

}

/** 响应：时间范围发生变化 */
function timeRangeChange() {
  freshPageData();
}

/** 设置日期的禁选范围 */
function disabledDate(date) {
  return date > dayjs() || date < dayjs().subtract(6, "month").startOf("month");
}

/** 打印-抄表详情 */
function printFunc() {
  html2canvas(meterDetails.value, { scale: 6}).then(data => {
    const styleContent = `
      @media print {
        @page {

          /* 横向 */
          size: auto;

          /* 边距 上右下左 */
          margin: 10 10 ;

        }
          *{
          print-color-adjust: exact !important;
          }
      }
    `;
    // 创建style元素
    const styleTag = document.createElement("style"); // 创建用于print的样式元素
    styleTag.innerHTML = styleContent;
    styleTag.media = "print";

    // 创建iFrame，设置要打印的内容
    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.contentDocument.head.append(styleTag); // 设置iFrame内部样式
    iframe.contentDocument.body.append(data); // 设置iFrame内部数据
    iframe.contentDocument.close();
    iframe.contentWindow.print(); // 执行打印
    document.body.removeChild(iframe); // 移除iFrame
  });
}

/** 导出-抄表详情 */
function onExport() {
  const st = dayjs(queryForm.timer[0]).format("YYYY-MM-DD 00:00:00");
  const et = dayjs(queryForm.timer[1]).format("YYYY-MM-DD 23:59:59");
  ElMessageBox.confirm($str.getKey('收益管理/是否确认导出抄表结算数据？'), $str.getKey('收益管理/提示'),
    {
      confirmButtonText: $str.getKey('收益管理/确定'),
      cancelButtonText: $str.getKey('收益管理/取消'),
      type: "warning"
    }
  )
    .then(() => {
      const params = {
        startTime: st,
        endTime: et,
        stationId: stationId.value
      };

      // download(
      //   "/dashboard/income/settlement/export",
      //   params,
      //   `statement_${new Date().getTime()}.xlsx`
      // );

      download_get('/dashboard/income/settlement/export', params, `statement_${new Date().getTime()}.xlsx`)
    })
    .catch(() => {});
}

/** ===== 业务方法：表格相关 ============================================================================ */
/** 设置表格相关的数据 */
function setTableData(resList) {
  const tableDataList = [];
  let totalPrice = 0;
  const rowsForPriceInfoList = [];
  resList.forEach(item => {
    totalPrice += item.income; // 累计【每个电价】的总收益
    const priceItemList = JSON.parse(item.price); // 获取一个【时段电价】中，包含的每项时段的电价信息

    // 对row对应的price-key进行排序
    const keyList = Object.keys(priceItemList);
    const priceDetailKeys = [];
    Object.keys(origin.priceKeyMap).forEach(key => {
      if (keyList.some(k => k == key)) {
        priceDetailKeys.push(key);
      }
    })

    // 规整：有N个电价，每个电价对应表格多少row
    const currHasTotalRows = rowsForPriceInfoList.reduce((sum, curr) => sum + curr.count, 0);
    const currPriceUseRows = priceDetailKeys.length;
    const startRowIdx = currHasTotalRows;
    const endRowIdx = startRowIdx + currPriceUseRows - 1;
    rowsForPriceInfoList.push({
      type: item.type,
      count: currPriceUseRows,
      startRowIdx,
      endRowIdx,
    });

    // 规整：表格每行的数据
    priceDetailKeys.forEach(key => {
      const rowInfo = cloneDeep(origin.tableRowInfo);
      rowInfo.priceType = origin.priceTypeMap[item.type];
      rowInfo.priceName = item.priceName;
      rowInfo.dayCount = item.count;
      // rowInfo.startTime = item.firstDate;
      // rowInfo.endTime = item.lastDate;
      rowInfo.timeRanges = item.timeRanges ?? [];
      rowInfo.totalAmount = item.income; // 合计

      const otherInfo = cloneDeep(origin.priceKeyMap[key]);
      rowInfo.timeRangeName = otherInfo.timeRangeName;

      rowInfo.price = getPrice(priceItemList[key]); // 市电电价
      rowInfo.direction = otherInfo.direction; // 计量方向
      const electricQuantityKey = otherInfo.electricQuantity;
      rowInfo.electricQuantity = item[electricQuantityKey]; // 电量
      rowInfo.electricCharge = calculateElectricCharge(rowInfo.price, rowInfo.electricQuantity, rowInfo.direction);

      tableDataList.push(rowInfo);
    })
  })

  tableInfo.dataList = tableDataList;
  tableInfo.totalPrice = totalPrice;
  tableInfo.styleInfo.priceList = rowsForPriceInfoList;
}

/** 设置【电表数据详情】面板的各tabs数据 */
function setMeterList(list = []) {
  try {
    const result = list.map(item => {
      let mtList = item.meterList.map(mt => {
        return {
          ...mt,
          parsedPrice: JSON.parse(mt.price),
          meterName: item.meterName
        };
      });
      return {
        id: item.id,
        meterName: item.meterName,
        stationId: item.stationId,
        uuid: item.uuid,
        meterList: mtList
      };
    });
    meterInfo.dataList = result;
  } catch (error) {
    console.warn(error);
  }
}

/** 【抄表详情】表格-合并单元格 */
function mergeCellsMethod({ row, column, rowIndex, columnIndex }) {
  // 设置[收益类别]合并为一个cell >>> columnIndex-0
  if (columnIndex === 0) {
    if (rowIndex % tableInfo.dataList.length === 0) {
      return {
        rowspan: tableInfo.dataList.length,
        colspan: 1
      };
    } else {
      return {
        rowspan: 0,
        colspan: 0
      };
    }
  }

  // 设置[电价类型]合并，每一大类电价合并为一个cell >>> 根据每个电价占的行数，合并&自适应
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 9) {
    const priceRowsInfo = tableInfo.styleInfo.priceList.find(price => price.startRowIdx == rowIndex);
    if (priceRowsInfo) {
      return {
        rowspan: priceRowsInfo.count,
        colspan: 1
      }
    } else {
      return {
        rowspan: 0,
        colspan: 0
      };
    }
  }

  // 设置[时段]合并，相同名称的【充放电时段】合并为一个cell
  if (columnIndex === 4) {
    if (rowIndex % 2 === 0) {
      return {
        rowspan: 2,
        colspan: 1
      };
    } else {
      return {
        rowspan: 0,
        colspan: 0
      };
    }
  }
}

/** 给最右侧的合计单元格设置class-name */
function setClassNameForCell(data) {
  // 给每个电价块的第一行添加分割线 & 给【合计单元格】添加文字样式
  const rowIndex = data.rowIndex;
  if (rowIndex != 0 && tableInfo.styleInfo.priceList.some(price => price.startRowIdx == rowIndex)) {
    if (data.column.label == $str.getKey('收益管理/合计(元)')) {
      return "next-block-row0 income-cell"; // 多个className之间用空格相隔
    } else {
      return "next-block-row0";
    }
  }
  if (data.column.label == $str.getKey('收益管理/合计(元)')) {
    return "income-cell";
  }
}

/** 获取合计行信息 */
function getSummaries() {
  const sums = Array(9);
  sums[0] = $str.getKey('收益管理/峰谷价差总收益-合计'); // 合计行文本内容
  sums[1] = "";
  sums[9] = fomatFloat(tableInfo.totalPrice, 4); // 计算结果
  return sums;
}

/** ===== 功能方法：辅助 ============================================================================ */
function fomatFloat(value, n) {
  let f = Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
  return f;
}

/** 计算电费 */
function calculateElectricCharge(price, electricQuantity, direction) {
  if (isNaN(price) || isNaN(electricQuantity)) {
    return 0;
  }

  const charge = fomatFloat(electricQuantity * price, 7);
  if (direction == $str.getKey('收益管理/充电')) {
    return 0 - charge;
  } else {
    return charge;
  }
};

/** 获取电价：有效的电价or-- */
function getPrice(price) {
  if (typeof(price) == "number") {
    return price;
  }
  if (typeof(price) == "string" && !isNaN(price) && price !== '') {
    return Number(price);
  }
  return '--';
}


</script>
<style lang="scss" scoped>
.page-container {
  --top-container-h: 80px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;

  .top-operate-panel {
    height: var(--top-container-h);
    background: var(--level1-bg-color);
    border-radius: 10px;
    border: 0px solid rgba(54, 62, 90, 0.7);
    display: flex;
    align-items: center;
    padding: 20px;

    .operate-form {
      padding-top: 16px;

      // 日期选择框样式
      :deep(.el-date-editor) {
        width: 294px !important;
        height: 40px !important;
        min-height: 40px !important;
        max-height: 40px !important;
        border-radius: 999px !important;

        // 范围选择器的外层容器
        &.el-range-editor {
          border-radius: 999px !important;
        }

        .el-input__wrapper {
          height: 40px !important;
          min-height: 40px !important;
          max-height: 40px !important;
          padding: 0 11px !important;
          box-sizing: border-box !important;
          border-radius: 999px !important;
        }

        .el-input__inner {
          height: 40px !important;
          line-height: 40px !important;
          color: rgba(46, 46, 46, 0.50) !important;
          font-family: "HarmonyOS Sans SC" !important;
          font-size: 14px !important;
          font-style: normal !important;
          font-weight: 300 !important;
          line-height: normal !important;
          padding: 0 !important;
          box-sizing: border-box !important;
          border-radius: 999px !important;
        }

        .el-input__prefix,
        .el-input__suffix {
          height: 40px !important;
          display: flex;
          align-items: center;
        }

        // 范围选择器的分隔符
        .el-range-separator {
          border-radius: 0 !important;
        }
      }

      // 查询按钮样式
      :deep(.el-button--primary) {
        width: 98px !important;
        height: 40px !important;
        min-height: 40px !important;
        max-height: 40px !important;
        padding: 0 !important;
        color: #FFF !important;
        background-color: var(--color-primary) !important;
        border-color: var(--color-primary) !important;
        font-family: "HarmonyOS Sans SC" !important;
        font-size: 14px !important;
        font-style: normal !important;
        font-weight: 400 !important;
        line-height: normal !important;
        box-sizing: border-box !important;
      }
    }
  }


  .read-meter-container {
    min-height: 450px;
    background: transparent; // 与主页面背景色一致
    border-radius: 10px;
    border: 0px solid rgba(54, 62, 90, 0.7);
    margin: 10px 0;
    padding: 20px;

    .panel-header-container {
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .titel-text {
        color: #2E2E2E;
        font-family: "HarmonyOS Sans SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .operate-btns {
        display: flex;
        gap: 12px;
        align-items: center;

        // 打印按钮样式(系统统一主色)
        :deep(.btn-print) {
          width: 98px !important;
          height: 40px !important;
          min-height: 40px !important;
          max-height: 40px !important;
          padding: 0 !important;
          color: #FFF !important;
          background-color: var(--color-primary) !important;
          border-color: var(--color-primary) !important;
          font-family: "HarmonyOS Sans SC" !important;
          font-size: 14px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: normal !important;
          box-sizing: border-box !important;

          span, .el-icon {
            color: #FFF !important;
          }
        }

        // 导出按钮样式(系统统一主色)
        :deep(.btn-export) {
          width: 98px !important;
          height: 40px !important;
          min-height: 40px !important;
          max-height: 40px !important;
          padding: 0 !important;
          color: #FFF !important;
          background-color: var(--color-primary) !important;
          border-color: var(--color-primary) !important;
          font-family: "HarmonyOS Sans SC" !important;
          font-size: 14px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: normal !important;
          box-sizing: border-box !important;

          span, .el-icon {
            color: #FFF !important;
          }
        }
      }
    }

    .panel-details-container {
      .table-content {
          // 表格内容字体样式
          font-size: 14px;
          color: #444A6D;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: "HarmonyOS Sans SC";
          font-style: normal;
          font-weight: 400;
          line-height: normal;

          // 移除表格背景色，与主页面保持一致
          :deep(.el-table) {
            background-color: transparent;
          }

          :deep(.el-table__header-wrapper) {
            background-color: transparent;
          }

          :deep(.el-table__body-wrapper) {
            background-color: transparent;
          }

          // 表头样式
          :deep(.el-table__header) {
            color: #96A5B8;
            font-family: "HarmonyOS Sans SC";
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
            background-color: transparent;

            th {
              color: #96A5B8;
              font-family: "HarmonyOS Sans SC";
              font-size: 13px;
              font-style: normal;
              font-weight: 400;
              line-height: 16px;
              background-color: transparent;

              .cell {
                color: #96A5B8;
                font-family: "HarmonyOS Sans SC";
                font-size: 13px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px;
              }
            }
          }

          // 表格内容单元格样式
          :deep(.el-table__body) {
            background-color: transparent;

            td {
              color: #444A6D;
              font-feature-settings: 'liga' off, 'clig' off;
              font-family: "HarmonyOS Sans SC";
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              background-color: transparent;

              .cell {
                color: #444A6D;
                font-feature-settings: 'liga' off, 'clig' off;
                font-family: "HarmonyOS Sans SC";
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
            }
          }

          .charge-type-cell {
            display: flex;
            align-items: center;

            .circle-symbol {
              width: 10px;
              height: 10px;
              background-color: currentColor;
              border-radius: 50%;
              margin: 0 10px;
              box-shadow: 0 0 10px currentColor;
            }
          }
          // 设置每个【尖峰平谷-时段电价块】的分割线 >>> 注意：每个block根据实际占的行数计算
          ::v-deep .next-block-row0 {
            border-top: 1px solid rgba(54, 62, 90, 0.7);
          }

          // 设置【合计(元)】cell的样式
          ::v-deep .income-cell {
            font-family: HelveticaNeue, HelveticaNeue;
            font-weight: bold;
            font-size: 16px;
            color: rgba(46, 46, 46, 1);
          }

      }

      .remark-info-container {
        margin-top: 20px;
        display: flex;
        flex-direction: column;

        .info-text {
          color: #000;
          font-family: "HarmonyOS Sans SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 300;
          line-height: 20px; /* 166.667% */
          text-align: left;
        }
      }
    }

  }

  .meter-datalist-container {
    flex-grow: 1;
    min-height: 200px;
    background: var(--level1-bg-color);
    border-radius: 10px;
    border: 0px solid rgba(54, 62, 90, 0.7);
    padding: 20px;

    display: flex;
    flex-direction: column;

    .content-title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .color-icon {
        width: 3px;
        height: 18px;
        background: #485e91;
        margin-right: 14px;
      }

      .text {
        color: #2E2E2E;
        font-family: "HarmonyOS Sans SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }

    .timeline-dot-symbol {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: 2px solid #EDF2F6 !important;
      background: transparent;
    }

    ::v-deep .el-timeline-item__tail {
      width: 0;
      height: 224px;
      border-left-width: 1px;
      border-left-style: solid;
      border-left-color: #EDF2F6 !important;
      left: 4px; // 圆圈中心位置 (10px / 2 = 5px, 减去边框宽度的一半)
      top: 10px;
    }

    .timeline-empty {
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #909399;
      font-size: 15px;
    }
  }

}

</style>
